import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import BookingForm from '../BookingForm';
import SEO from '../SEO.js';
import './ServicePages.css';


const CareGiver = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-now-hero-btn, .cta-button, .sidebar-book-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--primary-color)';
      button.style.border = 'none';
      button.style.color = 'var(--white-color)';
    });
  };

  const benefits = [
    'Personalized care in familiar surroundings',
    'Maintained independence and dignity',
    'Companionship and emotional support',
    'Peace of mind for family members',
    'Assistance with daily activities',
    'Reduced risk of falls and injuries'
  ];

  const careServices = [
    {
      name: 'Personal Care Assistance',
      description: 'Help with bathing, grooming, dressing, toileting, and other personal hygiene needs.'
    },
    {
      name: 'Companionship Care',
      description: 'Social interaction, conversation, accompaniment to appointments, and recreational activities.'
    },
    {
      name: 'Specialized Elder Care',
      description: 'Tailored care for seniors with age-related conditions, including mobility assistance and fall prevention.'
    },
    {
      name: 'Respite Care',
      description: 'Temporary relief for family caregivers who need a break from caregiving responsibilities.'
    }
  ];

  return (
    <div className="service-page care-giver-page">
      <SEO 
        title="Professional Caregiver Services in Bangalore"
        description="Compassionate caregiver services in Bangalore for elderly and patients. Our trained caregivers provide personal assistance, companionship, and daily living support."
        keywords="caregiver services Bangalore, elderly care at home, patient caretaker, home care assistance, companion for elderly"
      />
      <div className="service-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="service-hero-content">
                <h1>Professional Care Giver Services</h1>
                <p>Compassionate care and support for your loved ones at home</p>
                <Button className="book-now-hero-btn" onClick={handleBookNow}>
                  Book Appointment
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="service-hero-image">
                <img src="/images/care-giver.jpg" alt="Care Giver Services" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="service-content">
        <Row>
          <Col lg={8} md={12}>
            <div className="service-description">
              <h2>Compassionate Care Giving at Home</h2>
              <p>
                Our care giver services provide compassionate, non-medical assistance to individuals who need help with 
                daily activities. Our trained caregivers offer personalized support that enables clients to maintain 
                their independence while receiving the assistance they need in the comfort of their own homes.
              </p>
              <p>
                Whether you're looking for care for an elderly parent, a family member recovering from surgery, or someone 
                with a chronic condition, our caregivers provide reliable support tailored to your specific needs. We focus 
                on building meaningful relationships with our clients, ensuring they receive not just physical assistance but 
                also emotional support and companionship.
              </p>
              
              <h3>Our Care Giving Services</h3>
              <Row className="treatment-cards">
                {careServices.map((service, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card className="treatment-card h-100">
                      <Card.Body>
                        <Card.Title>{service.name}</Card.Title>
                        <Card.Text>{service.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              
              <h3 className="mt-4">What Our Care Givers Provide</h3>
              
            </div>
            <ul className="service-list">
                <li>Assistance with personal hygiene and grooming</li>
                <li>Meal planning and preparation</li>
                <li>Medication reminders</li>
                <li>Light housekeeping and laundry</li>
                <li>Grocery shopping and errands</li>
                <li>Transportation to appointments and social activities</li>
                <li>Companionship and emotional support</li>
                <li>Mobility assistance and fall prevention</li>
              </ul>
          </Col>
          
          <Col lg={4} md={12}>
            <div className="service-sidebar">
              <Card className="benefits-card">
                <Card.Header as="h5">Benefits of Home Care Giving</Card.Header>
                <Card.Body>
                  <ul className="benefits-list">
                    {benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="d-grid gap-2 mt-4">
                    <Button variant="primary" onClick={handleBookNow} className="sidebar-book-btn">
                      Request a Care Giver
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="why-choose-card mt-4">
                <Card.Header as="h5">Why Choose Our Care Givers?</Card.Header>
                <Card.Body>
                  <ul className="why-choose-list">
                    <li>Thoroughly screened and trained caregivers</li>
                    <li>Personalized care plans for each client</li>
                    <li>Flexible scheduling options</li>
                    <li>Regular quality assurance checks</li>
                    <li>Ongoing communication with family members</li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <div className="cta-section text-center">
              <h3>Need a Compassionate Care Giver?</h3>
              <p>Our professional caregivers are ready to provide the support and assistance your loved ones need.</p>
              <Button size="lg" onClick={handleBookNow} className="cta-button">
                Schedule a Care Consultation
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      
      <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Care Giver"
      />
    </div>
  );
};

export default CareGiver;
